import React from "react";

import BoldIcon from "@mui/icons-material/FormatBold";

import { ToggleButton } from "@/uiKit/atoms/ToggleButton.tsx";
import {
  RichTextToggleButtonsProps,
  toggleButtonStyles,
} from "@/uiKit/molecules/RichText/inputs/RichTextInputTypes.ts";

export const BoldToggleButton: React.FC<RichTextToggleButtonsProps> = props => (
  <ToggleButton data-action="common.rich-text.toggle-bold" value="bold" aria-label="bold" {...props}>
    <BoldIcon className={toggleButtonStyles.icon} />
  </ToggleButton>
);
